import React from 'react';

const CookieCategoryItem = ({ category, isActive, onToggle, showDetails }) => {
  const Icon = category.icon;

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden hover:border-gray-300 transition-colors">
      <div className="p-4 bg-gray-50 flex items-center justify-between">
        <div className="flex items-center space-x-3 flex-1">
          <Icon className="w-5 h-5 text-gray-700" />
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900">{category.title}</h3>
            {category.alwaysActive && (
              <span className="text-xs text-green-600 font-medium">
                {category.alwaysActiveText}
              </span>
            )}
          </div>
        </div>
        
        {category.alwaysActive ? (
          <div className="w-12 h-6 bg-green-500 rounded-full flex items-center justify-end px-1">
            <div className="w-4 h-4 bg-white rounded-full" />
          </div>
        ) : (
          <button
            onClick={() => onToggle(category.id)}
            className={`w-12 h-6 rounded-full transition-colors ${
              isActive ? 'bg-blue-500' : 'bg-gray-300'
            } flex items-center ${
              isActive ? 'justify-end' : 'justify-start'
            } px-1`}
            aria-label={`Toggle ${category.title}`}
          >
            <div className="w-4 h-4 bg-white rounded-full" />
          </button>
        )}
      </div>
      
      {showDetails && (
        <div className="p-4 bg-white border-t border-gray-200">
          <p className="text-sm text-gray-600">{category.description}</p>
        </div>
      )}
    </div>
  );
};

export default CookieCategoryItem;
